/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_6a920d7e',
  item: 'item_6a920d7e',
};

export = styles;

loadStyles([{"rawString":".root_6a920d7e{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.item_6a920d7e{-ms-flex-negative:0;flex-shrink:0}"}]);
/* tslint:enable */